// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: sensor_msgs/msg/NavSatStatus.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "sensor_msgs.msg.pb";

/**
 * Navigation Satellite fix status for any Global Navigation Satellite System.
 *
 * Whether to output an augmented fix is determined by both the fix
 * type and the last time differential corrections were received.  A
 * fix is valid when status >= STATUS_FIX.
 */
export interface NavSatStatus {
  status: NavSatStatus_StatusEnum;
  service: NavSatStatus_ServiceEnum;
}

export enum NavSatStatus_StatusEnum {
  /** STATUS_FIX - unaugmented fix */
  STATUS_FIX = 0,
  /** STATUS_NO_FIX - unable to fix position */
  STATUS_NO_FIX = -1,
  /** STATUS_SBAS_FIX - with satellite-based augmentation */
  STATUS_SBAS_FIX = 1,
  /** STATUS_GBAS_FIX - with ground-based augmentation */
  STATUS_GBAS_FIX = 2,
}

export function navSatStatus_StatusEnumFromJSON(object: any): NavSatStatus_StatusEnum {
  switch (object) {
    case 0:
    case "STATUS_FIX":
      return NavSatStatus_StatusEnum.STATUS_FIX;
    case -1:
    case "STATUS_NO_FIX":
      return NavSatStatus_StatusEnum.STATUS_NO_FIX;
    case 1:
    case "STATUS_SBAS_FIX":
      return NavSatStatus_StatusEnum.STATUS_SBAS_FIX;
    case 2:
    case "STATUS_GBAS_FIX":
      return NavSatStatus_StatusEnum.STATUS_GBAS_FIX;
    default:
      return NavSatStatus_StatusEnum.STATUS_NO_FIX;
  }
}

export function navSatStatus_StatusEnumToJSON(object: NavSatStatus_StatusEnum): string {
  switch (object) {
    case NavSatStatus_StatusEnum.STATUS_FIX:
      return "STATUS_FIX";
    case NavSatStatus_StatusEnum.STATUS_NO_FIX:
      return "STATUS_NO_FIX";
    case NavSatStatus_StatusEnum.STATUS_SBAS_FIX:
      return "STATUS_SBAS_FIX";
    case NavSatStatus_StatusEnum.STATUS_GBAS_FIX:
      return "STATUS_GBAS_FIX";
    default:
      return "STATUS_NO_FIX";
  }
}

export enum NavSatStatus_ServiceEnum {
  SERVICEENUM_UNSPECIFIED = 0,
  /**
   * SERVICE_GPS - Bits defining which Global Navigation Satellite System signals were
   * used by the receiver.
   */
  SERVICE_GPS = 1,
  SERVICE_GLONASS = 2,
  /** SERVICE_COMPASS - includes BeiDou. */
  SERVICE_COMPASS = 4,
  SERVICE_GALILEO = 8,
  UNRECOGNIZED = -1,
}

export function navSatStatus_ServiceEnumFromJSON(object: any): NavSatStatus_ServiceEnum {
  switch (object) {
    case 0:
    case "SERVICEENUM_UNSPECIFIED":
      return NavSatStatus_ServiceEnum.SERVICEENUM_UNSPECIFIED;
    case 1:
    case "SERVICE_GPS":
      return NavSatStatus_ServiceEnum.SERVICE_GPS;
    case 2:
    case "SERVICE_GLONASS":
      return NavSatStatus_ServiceEnum.SERVICE_GLONASS;
    case 4:
    case "SERVICE_COMPASS":
      return NavSatStatus_ServiceEnum.SERVICE_COMPASS;
    case 8:
    case "SERVICE_GALILEO":
      return NavSatStatus_ServiceEnum.SERVICE_GALILEO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NavSatStatus_ServiceEnum.UNRECOGNIZED;
  }
}

export function navSatStatus_ServiceEnumToJSON(object: NavSatStatus_ServiceEnum): string {
  switch (object) {
    case NavSatStatus_ServiceEnum.SERVICEENUM_UNSPECIFIED:
      return "SERVICEENUM_UNSPECIFIED";
    case NavSatStatus_ServiceEnum.SERVICE_GPS:
      return "SERVICE_GPS";
    case NavSatStatus_ServiceEnum.SERVICE_GLONASS:
      return "SERVICE_GLONASS";
    case NavSatStatus_ServiceEnum.SERVICE_COMPASS:
      return "SERVICE_COMPASS";
    case NavSatStatus_ServiceEnum.SERVICE_GALILEO:
      return "SERVICE_GALILEO";
    case NavSatStatus_ServiceEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseNavSatStatus(): NavSatStatus {
  return { status: 0, service: 0 };
}

export const NavSatStatus: MessageFns<NavSatStatus> = {
  encode(message: NavSatStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(3624117760).int32(message.status);
    }
    if (message.service !== 0) {
      writer.uint32(216912080).int32(message.service);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NavSatStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNavSatStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 453014720: {
          if (tag !== 3624117760) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 27114010: {
          if (tag !== 216912080) {
            break;
          }

          message.service = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NavSatStatus {
    return {
      status: isSet(object.status) ? navSatStatus_StatusEnumFromJSON(object.status) : 0,
      service: isSet(object.service) ? navSatStatus_ServiceEnumFromJSON(object.service) : 0,
    };
  },

  toJSON(message: NavSatStatus): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = navSatStatus_StatusEnumToJSON(message.status);
    }
    if (message.service !== 0) {
      obj.service = navSatStatus_ServiceEnumToJSON(message.service);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NavSatStatus>, I>>(base?: I): NavSatStatus {
    return NavSatStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NavSatStatus>, I>>(object: I): NavSatStatus {
    const message = createBaseNavSatStatus();
    message.status = object.status ?? 0;
    message.service = object.service ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
